var React = require('react');

function Fond10 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st3{fill:#082144;}\r\n"),React.createElement("path",{"id":"XMLID_2_","className":"st3","d":"M0,0c0.2,0,0.5,0,0.6,0.1C3,1.2,5.4,2.4,7.8,3.5c1.7,0.8,3.4,1.5,5.2,2.1\r\n\tc10.1,3.9,20.6,6.5,31.3,8.1c8.5,1.2,17,1.8,25.6,1.5c11.4-0.4,22.5-2,33.4-5.2c6.9-2,14-3.3,21.1-4c8.2-0.9,16.3-1.1,24.5-0.5\r\n\tc13.3,0.9,26.4,3.4,39,7.8c6.8,2.4,13.4,5.3,19.7,8.8c5.3,2.9,10.8,5.4,16.4,7.4c0.8,0.3,1.6,1,2.6,0.8c0,18.2,0,36.5,0,54.7\r\n\tc-75.5,0-151,0-226.6,0C0,56.6,0,28.3,0,0z","key":1})]);
}

Fond10.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 226.6 84.9","style":{"enableBackground":"new 0 0 226.6 84.9"},"xmlSpace":"preserve"};

module.exports = Fond10;

Fond10.default = Fond10;
